var map = {
	"./align_center_vertical.png": 616,
	"./alignment_up.png": 3597,
	"./angle.png": 4121,
	"./area_chart.svg": 2275,
	"./area_stacked_chart.svg": 2205,
	"./back.png": 547,
	"./backward.png": 1731,
	"./bar_chart.svg": 6639,
	"./bar_stacked_chart.svg": 2452,
	"./bg-mask.jpg": 4042,
	"./block.svg": 3662,
	"./center_align_horizontal.png": 7364,
	"./column_chart.svg": 6462,
	"./column_stacked_chart.svg": 7545,
	"./diagram.svg": 2473,
	"./file.svg": 3988,
	"./forward.png": 4969,
	"./front.png": 7924,
	"./iconsUI.svg": 7336,
	"./left_align.png": 1415,
	"./line_chart.svg": 5094,
	"./mocky_icon.png": 928,
	"./network.svg": 4398,
	"./object_alignment.png": 8121,
	"./pie_chart.svg": 6232,
	"./polar_chart.svg": 7932,
	"./radar_chart.svg": 9858,
	"./right_align.png": 9426,
	"./rotate_180.png": 8874,
	"./rotate_90.png": 5307,
	"./rounder_corner.svg": 8530,
	"./stroke.svg": 9271,
	"./stroke_dash.svg": 2870
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5811;